.tag {
  font-size: calc(1rem - 3px);
  letter-spacing: 0.5px;
  border-radius: 2px;
  padding: 0 0.25rem;
  white-space: nowrap;
}

.default {
  background-color: $gray-900;
  color: $ui-white;
}

.active {
  border: 1px solid $green-700;
  color: $green-400;
}

.warning {
  background-color: $orange-1300;
  color: $orange-300;
}
